import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export const popdartsCommissionInvoiceXlsxFileDataSchema = yup.object().shape({
  organization: yup.object().shape({
    companyName: yup.string().nullable().optional(),
    addressLine1: yup.string().nullable().optional(),
    addressLine2: yup.string().nullable().optional(),
    cityStateZip: yup.string().nullable().optional(),
  }),
  destination: yup
    .object()
    .shape({
      company: yup.string().nullable().optional(),
      addressLine1: yup.string().nullable().optional(),
      addressLine2: yup.string().nullable().optional(),
      cityStateZip: yup.string().nullable().optional(),
      contactName: yup.string().nullable().optional(),
      contactFullName: yup.string().nullable().optional(),
      contactEmail: yup.string().nullable().optional(),
      contactPhone: yup.string().nullable().optional(),
    })
    .required(),
  customerId: yup.string().nullable().optional(),
  date: yup.string().nullable().optional(),
  terms: yup.string().nullable().optional(),
  items: yup
    .array()
    .of(
      yup.object().shape({
        customerName: yup.string().nullable().optional(),
        city: yup.string().nullable().optional(),
        zip: yup.string().nullable().optional(),
        po: yup.string().nullable().optional(),
        salesPerson: yup.string().nullable().optional(),
        shipDate: yup.string().nullable().optional(),
        totalCost: yup.string().nullable().optional(),
        commissionRate: yup.string().nullable().optional(),
        commissionDue: yup.string().nullable().optional(),
      }),
    )
    .required(),
})

export type PopdartsCommissionInvoiceXlsxFileData = yup.InferType<
  typeof popdartsCommissionInvoiceXlsxFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<PopdartsCommissionInvoiceXlsxFileData>

export const popdartsCommissionInvoiceXlsxFileMappings: RequiredFileData = {
  organization: {
    companyName: 'a2f23f87-bc2c-4ac0-a398-e76f38d87f83',
    addressLine1: 'b8c8f515-b13f-4ddf-83fc-c119b768fc0c',
    addressLine2: '1c5c5ae3-8b34-4ef3-89ae-630d1e553898',
    cityStateZip: '7468b28d-0eec-402a-b6b2-3f1d59f9f2c5',
  },
  destination: {
    company: '0f13910e-e8d9-441e-a3ee-0a92b349ef16',
    addressLine1: 'f2b27fe2-6dd2-4a7b-9476-0d2aa5148cc9',
    addressLine2: '541719f4-83e1-4b60-8ab3-c83cd3322d6b',
    cityStateZip: '6c5d13a0-e3c7-4658-9df1-236c7414b4b6',
    contactName: '4e38ea0e-d21e-4f59-a2f8-4f374f30344e',
    contactFullName: 'cb1a7f78-13ae-4a7f-a1c6-44f315bd92be',
    contactEmail: 'c3c1a0b0-dbe1-4c92-bb96-356b8cb6ea57',
    contactPhone: 'ce9a20dc-7d7c-40b3-9d59-02c216f87203',
  },
  customerId: '4a74f3ad-6d1a-47db-8884-d5539b6b96cb',
  date: '547f3f74-1c4c-4fd8-9d2a-14a49f270b44',
  terms: '7ef2ea42-18e8-4475-9c1f-d924e10a3c5f',
  items: [
    {
      customerName: '1a377a8c-13ef-4625-b184-6b942dfdc8e7',
      city: '2f86a604-9d1f-4b2a-a719-89a0d4b2066f',
      zip: '316401e3-2c1b-4934-a305-e5f76e8ac582',
      po: '1abf7ebc-67c0-47d4-89b3-bbc9c15dc231',
      salesPerson: 'f9989f67-8052-4f66-8f4b-9e1a2923d2e4',
      shipDate: '8d29f378-4b24-41c4-9843-66a6f9093241',
      totalCost: 'af4cc85e-9ea0-4041-88a2-8bdabcbec499',
      commissionRate: '1a8a876f-1d56-4123-a142-e9dfb1c1bb0b',
      commissionDue: 'e64b1cf4-3276-4a2f-b7d3-d1cf5d8ea2ac',
    },
  ],
}
